<div class="modal-header">
  <h4 class="modal-title">@if(nuevoNivel){ Nuevo nivel } @else {Editar nivel: {{nivelSeleccionado.nombreNivel}}}</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="onCancelar()" aria-label="Cerrar"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div>
      <label class="form-label">Asignar nombre de nivel</label>
      <input type="text" class="form-control" formControlName="nombreNivel" />
      <div
        *ngIf="nombreNivel.invalid && nombreNivel.errors.required && (nombreNivel.dirty || nombreNivel.touched)"
        class="alert alert-danger">Requerido
      </div>
    </div>

    <div class="row fw-bold text-center my-3">
      <div class="col-6">Máximo</div>
      <div class="col-6">Activo</div>
    </div>

    <div class="row align-items-center">
      <div class="col-6">
        <label class="col-form-label">Excedido Autorizado DOL</label>
        <input class="form-control" formControlName="excedidoAutorizadoUSD" appOnlyNumber/>
      </div>
      <div class="col-6 text-center">
        <div class="form-check d-flex justify-content-center mt-2">
          <input class="form-check-input" type="checkbox" formControlName="excedidoActivo" />
        </div>
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-6">
        <label class="col-form-label">Vencido Autorizado DOL</label>
        <input class="form-control" formControlName="vencidoAutorizadoUSD" appOnlyNumber />
      </div>
      <div class="col-6 text-center">
        <div class="form-check d-flex justify-content-center mt-2">
          <input class="form-check-input" type="checkbox" formControlName="vencidoActivo" />
        </div>
      </div>
    </div>

    <div class="form-check mt-2">
      <input class="form-check-input" type="checkbox" formControlName="apruebaBloqueo" id="apruebaBloqueo" />
      <label class="form-check-label" for="apruebaBloqueo">
        Aprueba configuración de bloqueo de cuentas
      </label>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="text-end">
    <button (click)="onGuardar()" class="btn btn-primary me-3" [disabled]="guardandoCambios || !this.form.valid">
      <span *ngIf="!guardandoCambios">Guardar cambios</span>
      <div *ngIf="guardandoCambios" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Guardando...</span>
      </div>
    </button>
    <button type="button" class="btn btn-secondary" (click)="onCancelar()">Cancelar</button>
  </div>
</div>
